import { render, staticRenderFns } from "./sidebar-satispay.vue?vue&type=template&id=7c6519a1&"
import script from "./sidebar-satispay.vue?vue&type=script&lang=js&"
export * from "./sidebar-satispay.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-satispay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports